import * as React from "react"
import * as styles from "../styles/footer.module.css"

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <p className={styles.us}>© 2024 イースニッド</p>
            <p className={styles.steam_caption}>©2024 Valve Corporation. Steamworks及びSteamworksロゴは、米国及びまたはその他の国のValve Corporationの商標及びまたは登録商標です。
</p>
        </footer>
    )
}